import { useEffect, useMemo, useState } from 'react'
import { ComponentTrophyDto } from '~/modules/Products/Infrastructure/Dtos/ComponentTrophyDto'
import { TrophyMemoriesFilter } from '~/modules/Trophies/Application/TrophyListFilters'

export type SortMode = 'recent' | 'competition'

export interface GalleryMemoriesFilterOption {
  labelKey: string
  value: TrophyMemoriesFilter
}

export const galleryMemoriesFilterOptions: GalleryMemoriesFilterOption[] = [
  {
    labelKey: 'memories_filter_all',
    value: 0,
  },
  {
    labelKey: 'memories_filter_with_memories',
    value: 1,
  },
  {
    labelKey: 'memories_filter_multiple_memories',
    value: 2,
  },
]

interface Props {
  trophies: ComponentTrophyDto[]
  minMemories: TrophyMemoriesFilter
}

export function useGalleryToolbarState ({ trophies, minMemories }: Props) {
  const [searchTerm, setSearchTerm] = useState('')
  const [sortMode, setSortMode] = useState<SortMode>('recent')
  const [activeMemoriesFilter, setActiveMemoriesFilter] = useState<TrophyMemoriesFilter>(minMemories)

  useEffect(() => {
    setActiveMemoriesFilter(minMemories)
  }, [minMemories])

  const visibleTrophies = useMemo(() => {
    const normalizedSearch = searchTerm.trim().toLowerCase()
    let filteredTrophies = trophies

    if (normalizedSearch.length > 0) {
      filteredTrophies = trophies.filter((trophy) => {
        const searchIndex = [
          trophy.content.header,
          trophy.content.title,
          trophy.content.subtitle,
          trophy.discipline ?? '',
        ].join(' ').toLowerCase()

        return searchIndex.includes(normalizedSearch)
      })
    }

    if (sortMode === 'competition') {
      return [...filteredTrophies].sort((leftTrophy, rightTrophy) => {
        const leftValue = leftTrophy.content.header || leftTrophy.content.title
        const rightValue = rightTrophy.content.header || rightTrophy.content.title

        return leftValue.localeCompare(rightValue)
      })
    }

    return filteredTrophies
  }, [searchTerm, sortMode, trophies])

  return {
    activeMemoriesFilter,
    searchTerm,
    setActiveMemoriesFilter,
    setSearchTerm,
    setSortMode,
    sortMode,
    visibleTrophies,
  }
}
